import styled, { css } from "styled-components";
import { IStyledTitle } from "./interface";

const styledColors = {
	grey: css`
        color: var(--grey-lighter);
    `,
	purple: css`
        color: var(--purple-lighter);
    `,
	blue:  css`
        color: var(--blue-lighter);
    `,
	red: css`
        color: var(--red-lighter);
    `,
	yellow: css`
        color: var(--yellow-lighter);
    `,
	green: css`
        color: var(--green-lighter);
    `,
	black: css`
        color: #222;
    `,
	orange: css`
        color: var(--orange);
    `,
	defaultColor: css`
        color: var(--default-color-font);
    `
};

const styledSizes = {
	xs: css`
        font-size: 0.8rem;
    `,
	sm: css`
        font-size: 0.9rem;
    `,
	md: css`
        font-size: 1rem;
    `,
	lg: css`
        font-size: 1.1rem;
    `,
	xl: css`
        font-size: 1.2rem;
    `
};

const Container = styled.h3<IStyledTitle>`
  display: flex;
  align-items: center;
  
  ${(props) => props.marginBottom !== undefined && css`
    margin-bottom: ${props.marginBottom}px;
  `}
  ${(props) => props.marginTop !== undefined && css`
    margin-top: ${props.marginTop}px;
  `}
  ${(props) => props.bold && css`
    font-weight: bold;
  `}
  ${(props) => styledColors[props.color]}
  ${(props) => props.hexColor ? css`
    color: ${props.hexColor};
  ` : ""}
  ${(props) => styledSizes[props.size]}
  ${(props) => props.styleInline && props.styleInline}
`;

export default Container;
